export default "__VITE_ASSET__CoS6_5QQ__"